import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { ListsProvider } from "@/context/ListsContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import Dashboard from "@/pages/Dashboard";
import PublicShare from "@/pages/PublicShare";
import Agenda from "@/pages/Agenda";
import Jobs from "@/pages/Jobs";
import Artwork from "@/pages/Artwork";
import Website from "@/pages/Website";
import SendOffs from "@/pages/SendOffs";
import Quotes from "@/pages/Quotes";
import Customers from "@/pages/Customers";
import Setup from "@/pages/Setup";
import Standup from "@/pages/Standup";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ListsProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/share/:token" element={<PublicShare />} />
            <Route
              path="/change-password"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="standup" element={<Standup />} />
              <Route path="agenda" element={<Agenda />} />
              <Route path="jobs" element={<Jobs />} />
              <Route path="artwork" element={<Artwork />} />
              <Route path="website" element={<Website />} />
              <Route path="sendoffs" element={<SendOffs />} />
              <Route path="quotes" element={<Quotes />} />
              <Route path="customers" element={<Customers />} />
              <Route path="setup" element={<Setup />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors closeButton />
        </ListsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
